import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSession } from "@/lib/auth";
import { Spinner } from "@/ui/primitives";
import { garantirRegistro } from "@/lib/push";
import { marcarPresenca } from "@/lib/presenca";
import { conferirLembretes } from "@/lib/lembretes";

/**
 * Só passa quem está logado.
 *
 * Enquanto a sessão está sendo restaurada mostra o carregando — mandar para
 * o login nesse instante faria a tela piscar em toda abertura do app, que é
 * o tipo de defeito que ninguém reporta e todo mundo sente.
 *
 * O destino pretendido viaja no `state` para o login devolver a pessoa ao
 * lugar certo: quem abriu um convite quer cair no convite, não na home.
 */
export function Guard() {
  const { user, loading } = useSession();
  const location = useLocation();

  /* Reconserta o registro de notificação em silêncio a cada abertura.
     O servidor apaga tokens que o Firebase recusa, e um token bom apagado
     por engano deixava a pessoa sem receber nada, sem nenhum sinal na
     tela. Como a permissão já está dada, dá pra regravar sem perguntar —
     e sem permissão, a função sai na primeira linha. */
  const uid = user?.uid;
  useEffect(() => {
    if (!uid) return;
    void garantirRegistro(uid).catch(() => {});
    void marcarPresenca(uid);
    /* E reconserta a hora do lembrete se este aparelho mudou de fuso —
       normalmente sem custo nenhum, porque ele só vai ao banco quando o
       relógio mudou. Ver `lib/lembretes.ts`. */
    void conferirLembretes(uid);
  }, [uid]);

  if (loading) {
    return <div className="screen center"><Spinner /></div>;
  }
  if (!user) {
    return <Navigate to="/entrar" replace state={{ from: location.pathname + location.search }} />;
  }
  return <Outlet />;
}
